module.exports = __webpack_public_path__ + "img/Anniversary35A.7e961274.jpg";